import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';

import { GatedRouteEntitlement } from '~/components/app/GatedRouteEntitlement';
import { useEntitlements } from '~/hooks/account';
import { ConfigType } from '~/pages/configurations/Show/ConfigurationPanelFactory';
import TagsJs from '~/pages/configurations/Show/TagsJs';

import { settingsRoutes } from '../settingsRoutes';
import {
  PageAPIKeys,
  PageAPILogs,
  PageAPIUsage,
  PageGeneralAccount,
  PageGeneralBilling,
  PageGeneralNotifications,
  PageGeneralTeams,
  PageTeamGeneral,
  PageTeamUsers,
} from '.';

const Disconnected = lazy(() =>
  import('~/pages/configurations/Show/Disconnected'),
);
const ConfigurationPanelFactory = lazy(() =>
  import('~/pages/configurations/Show/ConfigurationPanelFactory'),
);

const {
  settingsIndexRoute,
  generalAccountRoute,
  generalTeamsRoute,
  generalNotificationsRoute,
  generalBillingRoute,
  teamGeneralRoute,
  teamUsersRoute,
  teamNotificationsRoute,
  // productsTargetMarketRoute,
  // productsVisitorReportRoute,
  apiKeysRoute,
  apiLogsRoute,
  apiUsageRoute,
  tagsJs,
} = settingsRoutes;

export const PageSettingsIndex = () => {
  const {
    hasAccessSettingsApi,
    hasAccessSettingsApiUsage,
    hasAccessSettingsIntegrations,
  } = useEntitlements();

  return (
    <Switch>
      {hasAccessSettingsIntegrations ? (
        <Route exact path={tagsJs}>
          <TagsJs />
        </Route>
      ) : null}

      {hasAccessSettingsIntegrations ? (
        <Route
          exact
          path="/settings/configuration/:service/connect"
          render={({
            match: {
              params: { service },
            },
          }) => <Disconnected service={service} />}
        />
      ) : null}

      {hasAccessSettingsIntegrations ? (
        <Route
          path="/settings/configuration/:service"
          render={({
            match: {
              params: { service },
            },
          }) => <ConfigurationPanelFactory config={service as ConfigType} />}
        />
      ) : null}

      <Route component={PageGeneralAccount} exact path={settingsIndexRoute} />

      <Route component={PageGeneralAccount} exact path={generalAccountRoute} />

      <Route component={PageGeneralTeams} exact path={generalTeamsRoute} />

      <Route
        component={PageGeneralNotifications}
        exact
        path={generalNotificationsRoute}
      />

      <Route component={PageGeneralBilling} exact path={generalBillingRoute} />

      <Route component={PageTeamGeneral} exact path={teamGeneralRoute} />

      <Route component={PageTeamUsers} exact path={teamUsersRoute} />

      <Route
        component={PageGeneralNotifications}
        exact
        path={teamNotificationsRoute}
      />

      <GatedRouteEntitlement
        component={PageAPIKeys}
        exact
        hasAccess={hasAccessSettingsApi}
        path={apiKeysRoute}
      />
      <GatedRouteEntitlement
        component={PageAPILogs}
        exact
        hasAccess={hasAccessSettingsApi}
        path={apiLogsRoute}
      />
      <GatedRouteEntitlement
        component={PageAPIUsage}
        exact
        hasAccess={hasAccessSettingsApiUsage}
        path={apiUsageRoute}
      />
    </Switch>
  );
};
